module.exports = __webpack_public_path__ + "img/image.ca71b3b1.png";